import api from './api'

/** 模型档案（对应后端 ai_model 表）。 */
export interface AdminAIModel {
  id?: number
  modelId: string
  displayName: string
  provider?: string
  apiBaseUrl?: string
  apiKeyRef?: string
  maxTokens?: number
  inputPricePer1k?: number
  outputPricePer1k?: number
  costMultiplier?: number
  temperature?: number
  available?: boolean
  isDefault?: boolean
  sortOrder?: number
  description?: string
}

export interface SystemApiConfig {
  baseUrl: string
  apiKeyMasked: string
  apiKeySet: boolean
}

export interface SettingItem {
  key: string
  encrypted: boolean
  description?: string
  value: string
  isSet?: boolean
}

export interface TestResult {
  ok: boolean
  category: string
  message: string
}

function unwrap<T>(res: any): T {
  return (res && res.data !== undefined ? res.data : res) as T
}

/** 统一 API 凭证 */
export const getSystemApiConfig = async (): Promise<SystemApiConfig> =>
  unwrap<SystemApiConfig>(await api.get('/admin/ai/system-config'))

export const updateSystemApiConfig = async (payload: {
  baseUrl?: string
  apiKey?: string
  clearApiKey?: boolean
}): Promise<void> => {
  await api.put('/admin/ai/system-config', payload)
}

/** 模型档案 CRUD */
export const listModels = async (): Promise<AdminAIModel[]> =>
  unwrap<AdminAIModel[]>(await api.get('/admin/ai/models')) || []

export const createModel = async (model: AdminAIModel): Promise<AdminAIModel> =>
  unwrap<AdminAIModel>(await api.post('/admin/ai/models', model))

export const updateModel = async (id: number, model: Partial<AdminAIModel>): Promise<AdminAIModel> =>
  unwrap<AdminAIModel>(await api.put(`/admin/ai/models/${id}`, model))

export const deleteModel = async (id: number): Promise<void> => {
  await api.delete(`/admin/ai/models/${id}`)
}

export const setDefaultModel = async (id: number): Promise<void> => {
  await api.put(`/admin/ai/models/${id}/default`, {})
}

export const testModel = async (modelId?: string): Promise<TestResult> =>
  unwrap<TestResult>(await api.post('/admin/ai/models/test', { modelId: modelId || '' }))

/** 其他系统配置 */
export const getSettings = async (): Promise<SettingItem[]> =>
  unwrap<SettingItem[]>(await api.get('/admin/ai/settings')) || []

export const updateSettings = async (changes: Record<string, string>): Promise<void> => {
  await api.put('/admin/ai/settings', changes)
}
